{
  "salon-details-header": {
    "buttons": {
      "link-copied": "ZKOPÍROVANÝ ODKAZ",
      "share": "PODÍL",
      "visit-virtually": "NAVŠTÍVIT SALON VIRTUÁLNĚ"
    }
  }
}
